import { render, staticRenderFns } from "./DocumentValidityQuery.vue?vue&type=template&id=5ddd561f"
import script from "./DocumentValidityQuery.vue?vue&type=script&lang=ts"
export * from "./DocumentValidityQuery.vue?vue&type=script&lang=ts"
import style0 from "./DocumentValidityQuery.vue?vue&type=style&index=0&id=5ddd561f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports